var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimcardOption = function SvgSimcardOption(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#simcard-option_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10h9v7h-9z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M14.7 20.51q.026.01.055.01a2.446 2.446 0 0 0 2.435-2.44V6.555a1.15 1.15 0 0 0-.394-.867L10.431.134a1.15 1.15 0 0 0-.756-.284H2.72A2.38 2.38 0 0 0 .35 2.22v15.93a2.36 2.36 0 0 0 2.36 2.36zM2.05 2.22c0-.367.303-.67.67-.67h6.435a.85.85 0 0 1 .559.21l5.485 4.784a.85.85 0 0 1 .291.64V18.08c0 .407-.333.74-.74.74H2.71a.657.657 0 0 1-.66-.66z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.92 9.08H5.43c-1.16 0-2.1.94-2.1 2.09v4.62c0 1.16.94 2.09 2.1 2.09h6.49c1.16 0 2.1-.94 2.1-2.09v-4.62c0-1.16-.94-2.09-2.1-2.09m.7 2.09v1.61H9.55v-2.31h2.37c.38 0 .7.31.7.7m-7.89 4.62v-4.62c0-.38.31-.7.7-.7h2.72v6.01H5.43c-.38 0-.7-.31-.7-.7zm7.19.7H9.55v-2.31h3.07v1.61c0 .38-.31.7-.7.7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "simcard-option_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.54,
    height: 20.36,
    x: 0.5,
    fill: "#fff",
    rx: 3
  })))));
};
export default SvgSimcardOption;